import { AccredibleDesign, AccrediblePageMeta, DesignType } from '@accredible-frontend-v2/models';

export enum DesignsQueryParam {
  SEARCH = 'search',
  KIND = 'kind',
  IN_USE = 'in_use',
  LANGUAGES = 'languages',
  SIZE = 'size',
  ORIENTATION = 'orientation',
  PAGE = 'page',
}

export interface DesignsListParams {
  page_size?: number;
  page?: number;
  design_identifier?: string;
  order?: string;
  in_use?: boolean;
  kind?: DesignType;
  size?: CertificatePaperSize[];
  orientation?: CertificateOrientation;
  languages?: string[];
}

export interface DesignsListResponse {
  meta: AccrediblePageMeta;
  designs: AccredibleDesign[];
  languages: string[];
}

export enum CertificatePaperSize {
  A4 = 'a4',
  A8 = 'a8',
  US_LETTER = 'us-letter',
}

export enum CertificateOrientation {
  LANDSCAPE = 'landscape',
  PORTRAIT = 'portrait',
}
